export default __webpack_public_path__ + "static/media/Spotify-logo.0bb47372.png";